import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { CoroutineScopefcb5f5dwqcas as CoroutineScope } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { initMetadataForInterface1egvbzx539z91 as initMetadataForInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  CloseReason10cphaqpp3ct7 as CloseReason,
  Codes_NORMAL_getInstance1akc4vzdzyb59 as Codes_NORMAL_getInstance,
  Codes_INTERNAL_ERROR_getInstance18ad4i9h6oigs as Codes_INTERNAL_ERROR_getInstance,
} from './CloseReason.mjs';
import { Close3tx65evcwi73t as Close } from './Frame.web.mjs';
import { CancellationException3b36o9qz53rgr as CancellationException } from '../../../../kotlin-kotlin-stdlib/kotlin/coroutines/cancellation/CancellationException.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *send(frame, $completion) {
  yield* this.o5f().g1b(frame, $completion);
  return Unit_instance;
}
var WebSocketSessionClass;
function WebSocketSession() {
  if (WebSocketSessionClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'WebSocketSession', VOID, VOID, [CoroutineScope()], [1, 0]);
    WebSocketSessionClass = $;
  }
  return WebSocketSessionClass;
}
function *close(_this__u8e3s4, reason, $completion) {
  reason = reason === VOID ? CloseReason().h5f(Codes_NORMAL_getInstance(), '') : reason;
  try {
    yield* _this__u8e3s4.p5f(Close().n5g(reason), $completion);
    yield* _this__u8e3s4.c4o($completion);
  } catch ($p) {
    if ($p instanceof Error) {
      var _unused_var__etf5q3 = $p;
    } else {
      throw $p;
    }
  }
  return Unit_instance;
}
function *closeExceptionally(_this__u8e3s4, cause, $completion) {
  var tmp;
  if (cause instanceof CancellationException()) {
    tmp = CloseReason().h5f(Codes_NORMAL_getInstance(), '');
  } else {
    tmp = CloseReason().h5f(Codes_INTERNAL_ERROR_getInstance(), cause.toString());
  }
  var reason = tmp;
  yield* /*#__NOINLINE__*/close(_this__u8e3s4, reason, $completion);
  return Unit_instance;
}
//region block: exports
export {
  send as send3kjrrxgwu0vpw,
  closeExceptionally as closeExceptionally3ggedzec0vibq,
  close as closeo8vfd19wahfw,
  WebSocketSession as WebSocketSessionzi1ianvyj32u,
};
//endregion

//# sourceMappingURL=WebSocketSession.mjs.map
